import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { DeleteHarvestCropComponent } from '../delete-harvest-crop/delete-harvest-crop.component';

@Component({
  selector: 'app-harvest-crop',
  templateUrl: './harvest-crop.component.html',
  styleUrls: ['./harvest-crop.component.scss'],
})
export class HarvestCropComponent implements OnInit {
  addCropName: FormGroup;
  cropDataList: any;
  selectedItems: any = [];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private _userService: UserManagementService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<HarvestCropComponent>
  ) {}

  ngOnInit(): void {
    this.formInIt();
    this.getManageCrop();
  }

  formInIt() {
    this.addCropName = this.fb.group({
      cropName: [
        '',
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
      date: [new Date()],
    });
  }

  getManageCrop() {
    this._userService.getHarvestCropList().subscribe((data: any) => {
      this.cropDataList = data.result.data;
    });
  }

  onClear() {
    this.dialogRef.close();
    this.router.navigate(['/add-harvest-crop']);
  }

  onSubmit() {
    if (this.addCropName.invalid) {
      this.toastr.warning('Please fill crop name');
      return false;
    } else {
      let body = {
        cropName: this.addCropName.value.cropName,
      };
      this._userService.postHarvestCrop(body).subscribe((data) => {
        if (data['result'].data == 1) {
          this.toastr.success(data['result'].message);
          this.addCropName.reset();
          this.getManageCrop();
        } else {
          this.toastr.error(data['result'].message, 'Error', {
            timeOut: 3000,
          });
        }
      });
    }
  }

  deleteCrop() {
    if (this.selectedItems?.length > 0) {
      var postdata = {
        removeCropList: this.selectedItems,
      };
      // required get Active Harvest Crop Api
      this._userService.getActiveHarvestCrop(postdata).subscribe((resp) => {
        if (resp['result']['data'] == 1) {
          var dialogRef = this.dialog.open(DeleteHarvestCropComponent, {
            width: '45%',
            height: 'auto',
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result.result === 'Yes') {
              this.selectedItems.map((ele) => {
                ele.remark = result.remark;
                delete ele.cropName;
              });
              const deleteBody = {
                removeCropList: this.selectedItems,
              };
              this._userService
                .deleteHarvestCrop(deleteBody)
                .subscribe((data) => {
                  if (data['result'].data == 1) {
                    this.toastr.success(data['result'].message);
                    this.selectedItems = [];
                    this.getManageCrop();
                  }
                });
            }
          });
        } else {
          this.toastr.error(resp['result']['message'], 'Error', {
            timeOut: 3000,
          });
        }
      });
    } else {
      this.toastr.warning('Please select any one crop!', 'Info', {
        timeOut: 3000,
      });
    }
  }

  itemToDelete(unitItems, event: Event) {
    if (this.selectedItems?.find((x) => x == unitItems)) {
      this.selectedItems?.splice(this.selectedItems?.indexOf(unitItems), 1);
    } else {
      this.selectedItems?.push(unitItems);
    }
  }
}
